export default "__VITE_ASSET__C51AOJbi__"